import React from "react";

export interface CustomerMetadata {
  jointAccount?: string;
  customerEmploymentStatus?: string;
  partnerEmploymentStatus?: string;
  haveChildrenUnder18?: string;
  accommodationType?: string;
  customerAge?: number;
  partnerAge?: number;
  dependentChildrenUnder16?: number;
  dependentChildrenAged16Plus?: number;
}

export const CustomerMetadataContext =
  React.createContext<CustomerMetadata>({});

export const useCustomerMetadata = (): CustomerMetadata =>
  React.useContext(CustomerMetadataContext);


